import React, { useState, useEffect, useCallback } from "react";
import useMutationObservable from "./useMutationObserver";

export default function useElementHeight(ref, dependencies = []) {
  const [height, setHeight] = useState(null);

  const handleResize = useCallback(() => {
    setTimeout(() => {
      const elem = ref?.current;
      if (!elem) return;
      setHeight(getElementHeight());
    }, 0);
  }, [ref]);

  const getElementHeight = () => {
    const elem = ref?.current;
    return Number(
      getComputedStyle(elem).getPropertyValue("height").replace("px", "")
    );
  };

  useEffect(() => {
    if (ref?.current) {
      setTimeout(() => {
        handleResize();
      }, 0);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, [ref, ...dependencies]);

  useMutationObservable(ref.current, handleResize);

  return [height, handleResize];
}
